import React, { useState } from 'react';
import AuthDropdownMenu from './auth-dropdown-menu';
import AuthMenuLoader from '@components/ui-old/loaders/auth-menu-loader';
interface Props {
  href: string;
  className?: string;
  btnProps: React.ButtonHTMLAttributes<any>;
  isAuthorized: boolean;
  loading: boolean;
  user?: {
    avatar: string;
    firstName: string;
    lastName: string;
    level: string;
  };
}
const formatLevel = (level?: string): string => {
  if (!level) return '';
  return level.split('_').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
};
export default function AuthMenu({
  isAuthorized,
  loading,
  className,
  btnProps,
  user
}: React.PropsWithChildren<Props>) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(prev => !prev);
  if (loading) {
    return <AuthMenuLoader className={className} />;
  }
  return isAuthorized && user ? <div className="relative" data-sentry-component="AuthMenu" data-sentry-source-file="auth-menu.tsx">
      <button onClick={toggleDropdown} className={`${className} flex items-center space-x-2 p-2 rounded-full transition duration-200 hover:bg-neutral-100 hover:dark:bg-neutral-800 hover:border hover:border-neutral-300 hover:dark:border-neutral-900`}>
        <img src={user.avatar || '/assets/images/default-avatar.png'} alt="User Avatar" className="w-10 h-10 rounded-full object-cover" onError={e => {
        e.currentTarget.src = '/assets/images/default-avatar.png';
      }} />
        <div className="flex flex-col items-start">
          <div className="flex items-center space-x-2">
            <span className="font-semibold text-neutral-900 dark:text-neutral-100">
              {user.firstName} {user.lastName}
            </span>
          </div>
          <span className="mt-1 text-xs font-regular bg-yellow-300 text-yellow-800 px-2 py-0.5 rounded-full shadow">
            {formatLevel(user.level)}
          </span>
        </div>
      </button>
      {dropdownOpen && <div className="absolute w-42">
          <AuthDropdownMenu onClose={() => setDropdownOpen(false)} />
        </div>}
    </div> : <button {...btnProps} className={className} data-sentry-component="AuthMenu" data-sentry-source-file="auth-menu.tsx" />;
}